'use client';

import { createSelectedBook } from '@/app/pages/home/utils';
import { formatSingleDestinationForCanvas } from '@/utils/formatDestinationForCanvas';

/**
 * Зарежда дестинация по slug, създава checkout draft и навигира към редактора.
 * Същият поток като StartDesignButton.
 */
export async function startDesignFromDestinationSlug({
  slug,
  templateIndex,
  destinationName,
  selectedTemplate,
  router,
}) {
  const res = await fetch(`/api/destinations/${encodeURIComponent(slug)}`);
  if (!res.ok) {
    throw new Error('Дестинацията не е намерена');
  }
  const data = await res.json();
  const destination = data?.destination;
  if (!destination?.templates?.length) {
    throw new Error('Няма корици за тази дестинация');
  }
  const destinationFormatted = formatSingleDestinationForCanvas(destination);
  if (!destinationFormatted?.details?.templates?.[templateIndex]) {
    throw new Error('Невалидна корица');
  }

  const template = selectedTemplate ?? destinationFormatted.details.templates[templateIndex];
  const selectedBook = createSelectedBook(
    destinationFormatted,
    destinationName ?? destinationFormatted?.details?.title ?? slug,
    [destinationFormatted],
    template,
    templateIndex,
  );
  if (!selectedBook) {
    throw new Error('Неуспешно създаване на избор');
  }

  const categoryKey = destinationName ?? destinationFormatted?.details?.title ?? slug;
  // Уникално ID на корицата: „категория-индекс“ — по него canvas зарежда точната корица
  // (същият формат като home flow). Без него draft-ът пада на индекс 0 → отваря грешна корица.
  const coverId = `${categoryKey}-${templateIndex}`;

  const draftRes = await fetch('/api/checkout-draft', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      createEmpty: true,
      coverId,
      category: categoryKey,
      templateIndex,
      title: selectedBook.title ?? destinationFormatted?.details?.title,
      selectedTemplate: selectedBook.selectedTemplate ?? null,
    }),
  });

  if (!draftRes.ok) {
    const errBody = await draftRes.json().catch(() => ({}));
    throw new Error(errBody?.error || draftRes.status);
  }

  const draftData = await draftRes.json();
  if (!draftData?.sessionId) {
    throw new Error('Липсва идентификатор на чернова.');
  }

  try {
    sessionStorage.setItem('checkout_draft_id', draftData.sessionId);
  } catch {
    // ignore
  }

  router.push(`/project?draft=${encodeURIComponent(draftData.sessionId)}`);
}
